"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EndpointCreatedEventData = void 0;
class EndpointCreatedEventData {
    constructor() {
    }
    static getAttributeTypeMap() {
        return EndpointCreatedEventData.attributeTypeMap;
    }
}
exports.EndpointCreatedEventData = EndpointCreatedEventData;
EndpointCreatedEventData.discriminator = undefined;
EndpointCreatedEventData.attributeTypeMap = [
    {
        "name": "appId",
        "baseName": "appId",
        "type": "string",
        "format": ""
    },
    {
        "name": "appUid",
        "baseName": "appUid",
        "type": "string",
        "format": ""
    },
    {
        "name": "endpointId",
        "baseName": "endpointId",
        "type": "string",
        "format": ""
    },
    {
        "name": "endpointUid",
        "baseName": "endpointUid",
        "type": "string",
        "format": ""
    }
];
//# sourceMappingURL=EndpointCreatedEventData.js.map